/**
 * Base URL for the polling page's meter list and production data (eleena-api).
 *
 *   '/eleena/api/v2'  ClickHouse (meter_data.dim_meter + pv_production)
 *   '/eleena/api/v1'  Postgres (energize + polling), the previous behaviour
 *
 * Both versions expose the same paths, parameters and response fields for:
 *   /meters, /meters/{serial}/quarter-hour-deltas, /daily-aggregates, /month-aggregates
 * so flipping this constant is the whole rollback. Everything else on the page
 * (meter detail, ping, poll, breaker, commands, power logs, alarms) stays on v1.
 */
export const READINGS_API_BASE = '/eleena/api/v2'

/**
 * Query parameters for /meters and /meters/export from the list filters
 * ({ source, c4a_account, customer_ids, alive, sim_provider }); arrays become repeated parameters.
 */
export function meterListParams(filters, extra = {}) {
  const params = new URLSearchParams(extra)
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) value.forEach((v) => params.append(key, v))
    else params.append(key, value)
  })
  return params
}
